import { Component, Input, Pipe, PipeTransform, ViewChild } from '@angular/core';
import { DomSanitizer, SafeResourceUrl } from '@angular/platform-browser';
import { environment } from '../../../../environments/environment';
import { SmsTemplate } from '../../case/components/case-card/components/tab-header-components/case-send-sms/case-send-sms.component';
import { Router } from '@angular/router';
import { AppMessageService } from '../../../shared/services/app-message/app-message.service';
import { SurveyDefinitionService } from '../service/survey-definition.service';
import { SmsTemplateService } from '../../definition/sms-template/services/sms-template.service';
import { SendMailSmsComponent } from '../../../ui-components/send-mail-sms/send-mail-sms.component';
import { finalize } from 'rxjs';

@Pipe({
  name: 'safeUrl'
})

export class SafeUrlPipe implements PipeTransform {
  constructor(private readonly sanitizer: DomSanitizer) { }

  transform(url: string): SafeResourceUrl {
    return this.sanitizer.bypassSecurityTrustResourceUrl(url);
  }

}

@Component({
  selector: 'app-case-surveys',
  templateUrl: './case-surveys.component.html',
  styleUrls: ['./case-surveys.component.scss']
})
export class CaseSurveysComponent {
  @Input() caseId: any;
  @Input() caseTypeId: any;

  isSurveysOpen: boolean = false;
  isSurveyDialogVisible: boolean = false;
  isSurveyAnswerDialog: boolean = false;
  isSurveyAnswerShowDialog: boolean = false;
  isSurveysPhone: boolean = false;

  // Patient data
  @Input() patient: any;
  @Input() patientPhones: string[] = [];

  // Survey data
  surveysOptions: any[] = [];
  selectedSurvey: number;
  surveyUrl: SafeResourceUrl | null = null;

  // SMS properties
  selectedPhoneForSurvey: string = '';
  smsTemplates: SmsTemplate[] = [];
  selectedSmsTemplate: any = null;
  selectedSmsTemplateContent: string = '';

  answersResponse: any;
  @ViewChild('sendManuelSMSMail') sendManuelSMSMail!: SendMailSmsComponent;
  selectedRaw: any;
  constructor(
    private readonly router: Router,
    private readonly sanitizer: DomSanitizer,
    private readonly messageService: AppMessageService,
    private readonly surveyService: SurveyDefinitionService,
    private readonly smsTemplateService: SmsTemplateService
  ) { }


  loadSmsTemplates() {
    this.smsTemplateService.getAllFilter({}, {
      'filter.isActive': true,
      'filter.getAll': true
    }).subscribe({
      next: (res) => {
        this.smsTemplates = res?.items ?? [];
        this.setDefaultSurveyTemplate();
      },
      error: (err) => {
        console.error('SMS şablonları yüklenemedi:', err);
      }
    });
  }

  setDefaultSurveyTemplate() {
    const surveyTemplate = this.smsTemplates.find((t: any) => {
      const name = t.templateName;
      return name?.toLocaleLowerCase() === 'anket gönderimi'.toLocaleLowerCase();
    });

    this.selectedSmsTemplate = surveyTemplate ?? this.smsTemplates[0] ?? null;
  }

  private checkSurveyAnswered(surveyId: number, answers: any[]) {
    return answers.some(ans => ans.survey?.id === surveyId);
  }

  private checkSurveySmsPending(answers: any[]) {
    return answers.some(ans =>
      (ans.smsLog?.isActive && !ans.smsLog?.isSubmitResponse) ??
      (ans.smsLogs?.isActive && !ans.smsLogs?.isSubmitResponse)
    );
  }

  private checkSurveyUserAnswered(surveyId: number, answers: any[]) {
    return answers.some(ans => ans.survey?.id === surveyId && ans.user);
  }

  private checkSurveyPhoneAnswered(surveyId: number, answers: any[]) {
    return answers.some(ans => ans.survey?.id === surveyId && ans.phoneNumber);
  }

  private hasCaseType(survey: any, caseTypeId: number): boolean {
    return survey.caseTypes?.some((ct: any) => ct.id === caseTypeId) ?? false;
  }

  openSurveysList() {
    if (!this.caseId) return;

    this.surveyService.getCaseAnswers(Number(this.caseId)).subscribe({
      next: (res: any[]) => {
        this.answersResponse = res;

        this.surveysOptions = (res ?? []).map(x => ({
          ...x.survey,
          caseSurvey: x.caseSurvey,
          isAnswered: x.isAnswered,
          isSmsTrue: x.isSmsTrue,
          userAnswered: x.userAnswered,
          phoneAnswered: x.phoneAnswered,
        }));
      },
      error: (err) => console.error(err),
    });

    this.isSurveysOpen = true;
  }

  private getCaseSurveyIdForSurvey(surveyId: number): number | null {
    const row = (this.answersResponse ?? []).find((x: any) => x?.survey?.id === surveyId);
    return row?.caseSurvey?.id ?? null;
  }

  selectSurvey(survey: any) {
    this.isSurveysOpen = false;
    // const url = this.router.createUrlTree([
    //   'pool',
    //   survey.id,
    //   'case',
    //   this.caseId,
    //   'answer'
    // ]).toString();
    const caseSurveyId = this.getCaseSurveyIdForSurvey(survey.id);
    const url = this.router.createUrlTree(['pool', caseSurveyId, 'answer']).toString();
    this.isSurveyDialogVisible = true;
    this.surveyUrl = this.sanitizer.bypassSecurityTrustResourceUrl(url);

    this.isSurveyAnswerDialog = true;
  }


  showSurveyAnswers(survey: any) {
    this.isSurveysOpen = false;
    const caseSurveyId = this.getCaseSurveyIdForSurvey(survey.id);
    const url = this.router.createUrlTree(['pool', caseSurveyId, 'answer']).toString();
    this.isSurveyDialogVisible = true;
    this.surveyUrl = this.sanitizer.bypassSecurityTrustResourceUrl(url);

    this.isSurveyAnswerShowDialog = true;

  }

  closeSurveyDialog() {
    this.isSurveyDialogVisible = false;
    this.surveyUrl = null;
  }

  sendSurveyPhoneNumber(survey: any) {
    this.loadSmsTemplates();

    this.isSurveysPhone = true;
    this.selectedSurvey = survey.id;
    this.selectedPhoneForSurvey = '';
  }

  selectPhoneForSurvey(phone: string) {
    this.selectedPhoneForSurvey = phone;
  }

  clearPhoneSelection() {
    this.selectedPhoneForSurvey = '';
  }

  getSmsContent(): string {
    if (!this.selectedSmsTemplate) {
      return '';
    }
    ;
    let content = this.selectedSmsTemplate.content ?? this.selectedSmsTemplate.templateContent ?? '';

    const surveyLink = this.generateSurveyLink();

    const fullName = `${this.patient.firstName} ${this.patient.lastName}`;
    content = content.replaceAll('[İsim Soyisim]', fullName);
    this.selectedSmsTemplateContent = content;
    content = content.replaceAll('[Link]', surveyLink);

    if (!content.trim()) {
      content = `Merhaba, anket doldurmanız beklenmektedir. Lütfen aşağıdaki linke tıklayarak anketi doldurunuz: ${surveyLink}`;
    }

    return content;
  }

  private generateSurveyLink(): string {
    const baseUrl = environment.citizenMobileUrl ?? globalThis.location.origin;
    return `${baseUrl}pool/${this.selectedSurvey}/case/${this.caseId}`;
  }

  sendSurveyToPhone(phone: string) {
    if (!this.selectedSurvey || !phone) {
      this.messageService.warningToast('', 'Lütfen telefon numarası seçiniz.');
      return;
    }

    this.surveyService.sendSurveySMS({
      type: 'internal',
      surveyId: this.selectedSurvey,
      caseId: Number(this.caseId),
      phones: [phone],
      content: this.selectedSmsTemplateContent
    }).subscribe({
      next: () => {
        this.messageService.successToast('', 'Anket SMS\'i başarıyla gönderildi.');
        this.isSurveysPhone = false;
      },
      error: (err: any) => {
        console.error('SMS gönderme hatası:', err);
        this.messageService.errorToast('SMS gönderilirken bir hata oluştu.', err?.message ?? err?.error?.messa);
      }
    });
  }

  cancelSurveySms() {
    this.isSurveysPhone = false;
    this.clearSurveyDialog();
  }

  clearSurveyDialog() {
    this.selectedPhoneForSurvey = '';
    this.selectedSurvey = 0;
  }

  sendManuelSMS(item: any) {
    // item.caseSurvey.isExternal;
    // item.caseSurvey.case,
    // item.caseSurvey.case?.patientInformations?.contacts
    if (!item) return;
    this.selectedRaw = item;
    this.sendManuelSMSMail.open(item?.caseSurvey?.case?.id, item?.caseSurvey?.case?.patientInformations?.contacts, 'sms');

  }

  handleSMSAction(event: any) {
    try {
      const receivers = Array.isArray(event.receivers) ? event.receivers : [];
      const phone = receivers.length ? receivers : null;
      const payload: any = {
        type: 'internal',
        surveyId: this.selectedRaw?.caseSurvey?.survey?.id,
        caseId: event.caseId,
        surveySearchId: this.selectedRaw.caseSurvey?.id,
        phones: phone
      }
      this.surveyService
        .sendSurveySMS(payload)
        .pipe(finalize(() => (this.selectedRaw = null)))
        .subscribe({
          next: () => {
            this.messageService.successToast('', "Anket SMS'i başarıyla gönderildi.");
          },
          error: (err) => {
            this.messageService.errorToast(
              'SMS gönderilirken bir hata oluştu.',
              err?.message ?? err?.error?.message
            );
          }
        });
    }
    finally {
      this.selectedRaw = null;

    }
  }
  onPopupClosed(){

  }
}
